import { IPaginationElement } from './pagination';

export class Alertas implements IPaginationElement {
    id: number;
    userId: number;
    clientRequestId: number;
    clientRequestName: string;
    requestId: number;
    contentId: number;
    state: number;
    message: string;
    sendedExt: number;
    date: string;
    isImportant: number;

    constructor() { }


    static toModel(json: string): Alertas {
        const data = JSON.parse(json);
        if (data === null) {
            return null;
        }
        const toReturn = new Alertas();
        toReturn.id = data.Id;
        toReturn.userId = data.ID_USUARIO;
        toReturn.clientRequestId = data.ID_CLIENTE_SOLICITUD;
        toReturn.clientRequestName = data.NOMBRE_CLIENTE_SOLICITUD;
        toReturn.requestId = data.ID_SOLICITUD;
        toReturn.contentId = data.ID_CONTENIDO;

        toReturn.message = data.MSG;
        toReturn.state = data.ESTADO;
        toReturn.isImportant = data.ES_IMPORTANTE;
        toReturn.date = data.FECHA;
        toReturn.sendedExt = data.ENVIADO_EXT;
        return toReturn;
    }
}
